<template>
  <div>
    <VerifyTyc />
    <!-- <div v-if="this.$store.state.tyc == 1"><verifyPromo /></div> -->
    <v-overlay :value="overlay" style="height: 100vh">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <iframe
      ref="gameFrame"
      :src="gameUrl"
      :style="
        size < 960
          ? 'width: 100%; height: calc(' + this.screenHeight * 0.93 + 'px)'
          : 'width: 100%; height: ' +
            (iframeIsGame ? 'calc(90vh)' : '93vh')
      "
      frameborder="0"
      @load="syncIframeUrlState"
    ></iframe>

    <MisCuentas />
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import MisCuentas from "../components/MisCuentas.vue";
import misCuentas from "../components/MisCuentas.vue";
//import verifyPromo from "../components/VerifyPromo.vue";
import VerifyTyc from "../components/VerifyTyc.vue";

export default {
  data() {
    return {
      gameUrl: null,
      overlay: true,
      isMobile: 0,
      misCuentas,
      multiplicador: 1,
      mon: null,
      screenHeight: 0,

      // ✅ NUEVO: controla el height en desktop según URL interna del iframe
      iframeIsGame: false,

      // ✅ NUEVO: para detectar cambios de URL internos (SPA) en same-origin
      iframeUrlPoll: null,
      lastIframeHref: null,
    };
  },
  watch: {
    idmoneda() {
      this.overlay = true;
      this.getGame();
      //this.showChat();
    },
  },
  beforeDestroy() {
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.onResize, { passive: true });

    // ✅ limpiar polling
    if (this.iframeUrlPoll) {
      clearInterval(this.iframeUrlPoll);
      this.iframeUrlPoll = null;
    }
  },
  mounted() {
    this.screenHeight = window.innerHeight;
    this.isMobile = window.innerWidth < 600 ? 1 : 0;
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });

    axios({
      method: "post",
      url: `details`,
    }).then((response) => {
      this.$store.state.nombre = response.data.success.name;
    });

    this.getSaldo();

    if (document.getElementById("fc_frame")) {
      document.getElementById("fc_frame").style.display = "none";
    }

    this.idpos = sessionStorage.getItem("idpos");
    this.getGame();

    // ✅ iniciar polling (mismo dominio) para detectar cambios internos
    this.startIframeUrlPolling();
  },
  updated() {
    if (document.getElementById("fc_frame")) {
      document.getElementById("fc_frame").style.display = "none";
    }
  },
  methods: {
    ...mapActions(["getSaldo"]),
    onResize() {
      this.isMobile = window.innerWidth < 600 ? 1 : 0;
    },

    // ✅ lee la URL interna del iframe y ajusta iframeIsGame
    syncIframeUrlState() {
      try {
        const iframe = this.$refs.gameFrame;
        if (!iframe || !iframe.contentWindow) return;

        const href = (iframe.contentWindow.location.href || "").toLowerCase();
        this.lastIframeHref = href;
        this.iframeIsGame = href.includes("game");
      } catch (e) {
        // same-origin debería permitirlo; si por alguna razón no, no rompe
      }
    },

    // ✅ polling para SPAs que cambian URL sin recargar (no dispara load)
    startIframeUrlPolling() {
      if (this.iframeUrlPoll) return;

      this.iframeUrlPoll = setInterval(() => {
        try {
          const iframe = this.$refs.gameFrame;
          if (!iframe || !iframe.contentWindow) return;

          const href = (iframe.contentWindow.location.href || "").toLowerCase();
          if (href && href !== this.lastIframeHref) {
            this.lastIframeHref = href;
            this.iframeIsGame = href.includes("game");
          }
        } catch (e) {
          // same-origin debería permitirlo; si no, simplemente no actualiza
        }
      }, 300);
    },

    getGame() {
      const offsetHours = -new Date().getTimezoneOffset() / 60;
      this.mon = "";
      this.multiplicador = 1;

      if (this.$store.state.idmoneda == 1) {
        this.mon = "VES";
        this.multiplicador = 218;
      } else if (this.$store.state.idmoneda == 2) this.mon = "USD";
      else if (this.$store.state.idmoneda == 3) this.mon = "PEN";
      else if (this.$store.state.idmoneda == 7) this.mon = "COP";
      else if (this.$store.state.idmoneda == 8) this.mon = "CLP";

      axios({
        method: "post",
        url: `https://trackandraces.com/onlineapi/api/casino/login`,
        data: {
          moneda: this.mon,
          timezone: offsetHours,
        },
      }).then((response) => {
        console.log(response);
        const url = response.data.message;
        this.gameUrl = url;
        //alert("Las unidades de su Cartera seran convertidas en Bolivares para realizar las Jugadas");
        this.overlay = false;

        // ✅ intenta sincronizar apenas se renderiza el iframe
        this.$nextTick(() => this.syncIframeUrlState());
      });
    },
  },
  computed: {
    size() {
      return this.$store.state.windowSize.x;
    },
    moneda() {
      return this.$store.state.moneda;
    },
    idmoneda() {
      return this.$store.state.idmoneda;
    },
    idsb() {
      return this.$store.state.idsb;
    },
    currentBalance() {
      return this.$store.state.currentBalance;
    },
    idpos: {
      get() {
        return this.$store.state.idpos;
      },
      set(e) {
        this.$store.state.idpos = e;
      },
    },
  },
  components: { MisCuentas, VerifyTyc },
};
</script>

<style>
header {
  background-color: #fa22229a;
  border-radius: 5px;
  color: #fff;
  padding: 1px;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 3px;
}

nav ul {
  list-style: none;
  padding: 3px;
  margin: 0;
}

nav li {
  display: inline; /* Hace que los ítems del menú estén en una línea horizontal */
  margin-right: 20px; /* Espacio entre los ítems del menú */
}

nav a {
  text-decoration: none;
  color: #fff !important;
  font-size: 16px;
}

nav a:hover {
  font-size: 17px;
  color: #000 !important;
}
</style>
